import { Pipe, PipeTransform } from '@angular/core';
import {
	coerceCurrency,
	Currency,
	currencyPrefix,
} from '@marmon/shared/types/common';

@Pipe({ name: 'dollarShorthand', standalone: true })
export class DollarShorthandPipe implements PipeTransform {
	transform(amount: number, currency?: Currency | null) {
		const shorthands = Object.values(DollarShorthand).sort(
			(a, b) => a.value - b.value,
		);

		let value = null;
		for (const shorthand of shorthands) {
			if (Math.abs(amount) >= shorthand.value) {
				const compact =
					(amount / shorthand.value).toFixed(1).replace(/\.0$/, '') +
					shorthand.label;
				value = `${currencyPrefix(coerceCurrency(currency))}${compact}`;
			}
		}
		return value;
	}
}

const DollarShorthand = {
	million: {
		value: 1000000,
		label: 'M',
	},
	billion: {
		value: 1000000000,
		label: 'B',
	},
	trillion: {
		value: 1000000000000,
		label: 'T',
	},
};
